module.exports = __webpack_public_path__ + "assets/images/TZ_HVAR.png";